import PointerPortal from '@custom/ui/helpers/PointerPortal';
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';

export function WrapWithCursor({ children }: { children: ReactNode }) {
  const [showCursor, setShowCursor] = useState(false);

  useEffect(() => {
    setShowCursor(true);
  }, []);

  return (
    <>
      {showCursor && <PointerPortal />}
      {children}
    </>
  );
}
